/**
 * Trading widget registry — single page-scoped instance.
 *
 * Constructed via the shared createWidgetRegistry() factory. Registrations
 * happen as side-effects in src/config/widgets/index.ts at module load time.
 */

import { createWidgetRegistry } from '../../components/grid-dashboard';

export const tradingWidgetRegistry = createWidgetRegistry();
